
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-upsc",
      function () {
        return require("private-next-pages/about-upsc/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-upsc"])
      });
    }
  